import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import SelectCompanyComboBox from '../../../components/SelectCompanyComboBox';
import emptyCheckmark from '../../../assets/images/empty-checkmark.svg';
import fillCheckmark from '../../../assets/images/fill-checkmark.svg';
import CollectionDataSource from '../../../dao/DataSource/CollectionDataSource';
import DataSource from '../../../dao/DataSource/DataSource';
import './VendorUserSelection.scss';

export class VendorUserSelection extends BaseComponent {

  constructor(props){
    super(props);

    this.state = {
      toBeAdded: [],
      toBeDeleted: [],
      usersToBeAdded: [],
      usersToBeDeleted: [],
    };
  }

  handleUpdateCompany(company, action, acData, fetchedData) {
    if (company) {
      this.setState({ company });
    }
  }

  handleUpdateMarkets(markets) {
    this.setState({ markets });
  }

  handleUpdateUsers(users) {
    this.setState({ vendorMarketUsers: users.users });
  }

  componentDidMount() {
    super.componentDidMount(this);
    this.marketsDataSource = new CollectionDataSource('MarketsCollection', 'Market', { market: { users: {} } }, this.handleUpdateMarkets);
    this.companyDataSource = new DataSource('Company', this.props.currentCompany, { company: { vendor_users: {}, vendor_companies: {} } }, this.handleUpdateCompany);

    this.companyDataSource.get();
    this.marketsDataSource.current();
  }

  componentWillUnmount() {
    if (this.companyDataSource) {
      this.companyDataSource.release();
      this.companyDataSource = null;
    }

    if (this.marketsDataSource) {
      this.marketsDataSource.release();
      this.marketsDataSource = null;
    }

    if (this.usersDataSource) {
      this.usersDataSource.release();
      this.usersDataSource = null;
    }
  }

  componentDidUpdate(){
    this.props.selectVendorUsers(this.state.toBeAdded, this.state.toBeDeleted, this.state.usersToBeAdded, this.state.usersToBeDeleted);
  }

  getDirectoryUsers(company) {
    if (company) {
      if (this.usersDataSource) {
        this.usersDataSource.release();
      }
      this.usersDataSource = new CollectionDataSource('UsersCollection',
        'User', { users: { markets: {}, market_vendor_users: { market: {} }, vendor_markets: {} } }, this.handleUpdateUsers, 'VendorUsers', null, null, null, company.id);
      this.usersDataSource.current();
    }
  }

  handleScrollCheckBoxes(e){
    let element = document.getElementById('market-titles');
    var scrollLeft = e.target.scrollLeft;
    element.scrollLeft = scrollLeft;
  }

  handleScrollTitles(e){
    let element = document.getElementById('market-checkboxes');
    var scrollLeft = e.target.scrollLeft;
    element.scrollLeft = scrollLeft;
  }

  handleCompanySelection(company) {
    if (!this.vendorCompanies) {
      this.vendorCompanies = {};
    } 
    if (!this.vendorCompanies[company.id]) {
      this.vendorCompanies[company.id] = company;
      this.vendorCompanies[company.id].vendor_users = [];
      if (this.state.company.vendor_users && this.state.company.vendor_users.vendors) {
        for (let i = 0; i < this.state.company.vendor_users.vendors.length; i++) {
          if(this.vendorCompanies[company.id].vendor_users){
            if(!this.vendorCompanies[company.id].vendor_users.vendors){
              this.vendorCompanies[company.id].vendor_users.vendors = [];
            }
            this.vendorCompanies[company.id].vendor_users.vendors.push(this.state.company.vendor_users.vendors[i]);
          }
        }
      }
      else if (this.state.company.vendor_users) {
        for (let i = 0; i < this.state.company.vendor_users.length; i++) {
          if(this.vendorCompanies[company.id]){
            if(!this.vendorCompanies[company.id].vendor_users){
              this.vendorCompanies[company.id].vendor_users = [];
            }
            let vendorUser = this.state.company.vendor_users[i];
            if (vendorUser.companies[0].id == company.id || vendorUser.companies[0] == company.id) {
              this.vendorCompanies[company.id].vendor_users.push(vendorUser);
            }
          }
        }
      }
    }
    this.companyUsers = [];
    this.getDirectoryUsers(company);
    this.setState({ selectedCompany: this.vendorCompanies[company.id] });
  }

  handleCheckmarkClick(e){
    let marketId = parseInt(e.target.getAttribute('data-market-id'), 10);
    let userId = parseInt(e.target.getAttribute('data-user-id'), 10);
    let companyId = this.state.selectedCompany.id;
    let toBeAdded = this.state.toBeAdded; 

    let users = this.state.vendorMarketUsers.map(user => {
      if(user.id == userId){
        let market = this.state.markets.filter(market => {
          return market.id == marketId;
        });
        if(user.vendor_markets.length == 0 || !user.vendor_markets.find(vm => {return vm.id == market.id;})){ // add user to company
          let usersToBeAdded = this.state.usersToBeAdded;
          if (!usersToBeAdded.find(u => { return u.id == user.id; })) {
            usersToBeAdded.push(user);
          }
          if(this.state.usersToBeDeleted.length){
            let delIndex = -1;
            this.state.usersToBeDeleted.forEach((delUser, index) => {
              if(delUser.id == user.id){
                delIndex = index;
              }
            });
            if(delIndex >= 0){
              let copyAdd = this.state.usersToBeDeleted;
              copyAdd.splice(delIndex, 1);
              this.setState({ usersToBeDeleted: copyAdd });
            }
            else{
              this.setState({ usersToBeAdded: usersToBeAdded });
            }
          }
        }
        user.vendor_markets.push(market[0]);

        let wasDeleted = this.state.toBeDeleted.findIndex(m => {
          return m.userId == userId && m.marketId == marketId && m.companyId == companyId;
        });
        if(wasDeleted > -1){
          let copyToBeDeleted = this.state.toBeDeleted;
          copyToBeDeleted.splice(wasDeleted, 1);
          this.setState({ toBeDeleted: copyToBeDeleted });
        }
        else{
          toBeAdded.push({
            userId: userId, 
            marketId: marketId, 
            companyId: companyId, 
          });
        }
      }
      return user;
    });

    this.setState({ 
      vendorMarketUsers: users,
      toBeAdded: toBeAdded,
    });
  }

  handleCheckmarkUnClick(e){
    let marketId = parseInt(e.target.getAttribute('data-market-id'), 10);
    let userId = parseInt(e.target.getAttribute('data-user-id'), 10);
    let companyId = this.state.selectedCompany.id;
    let toBeDeleted = this.state.toBeDeleted; 

    let users = this.state.vendorMarketUsers.map(user => {
      if(user.id == userId){
        let i;
        user.vendor_markets.forEach((vendorMarket, index) => {
          if (vendorMarket.id == marketId) {
            i = index;
          }
        });
        if (i > -1) {
          user.vendor_markets.splice(i, 1);
        }
        let wasAdded = this.state.toBeAdded.findIndex(m => {
          return m.userId == userId && m.marketId == marketId && m.companyId == companyId;
        });
        let copyToBeAdded = this.state.toBeAdded;
        if(wasAdded > -1){
          copyToBeAdded.splice(wasAdded, 1);
          this.setState({ toBeAdded: copyToBeAdded });
        }
        else{
          toBeDeleted.push({
            userId: userId, 
            marketId: marketId, 
            companyId: companyId, 
          });
        }
        const totalMarketsForCompany = !user.market_vendor_users ? 0 : user.market_vendor_users.filter((mvu) => {
          return mvu.market.company_id == this.props.currentCompany.id;
        }).length;
        let marketsRemoved = toBeDeleted.filter(tbd => {
          return tbd.userId == userId;
        }).length;
        let marketsAdded = !copyToBeAdded ? 0 : copyToBeAdded.filter(tba => {
          return tba.userId == userId;
        });
        if (totalMarketsForCompany && totalMarketsForCompany - marketsRemoved + marketsAdded <= 0) { // remove user from company
          let usersToBeDeleted = this.state.usersToBeDeleted;
          if(this.state.usersToBeAdded.length){
            let addIndex = -1;
            this.state.usersToBeAdded.forEach((addUser, index) => {
              if(addUser.id == user.id){
                addIndex = index;
              }
            });
            if(addIndex >= 0){
              let copyAdd = this.state.usersToBeAdded;
              copyAdd.splice(addIndex, 1);
              this.setState({ usersToBeAdded: copyAdd });
            }
            else{
              usersToBeDeleted.push(user);              
            }
          }
          else{
            usersToBeDeleted.push(user);
          }
          this.setState({ usersToBeDeleted: usersToBeDeleted });
        }
      }
      return user;
    });

    this.setState({ 
      vendorMarketUsers: users,
      toBeDeleted: toBeDeleted,
    });
  }

  render() {
    if (!this.state.markets) {
      return null;
    }
    let companySelector = null;
    companySelector = <div className="input-field field">
        <SelectCompanyComboBox 
          id={'select-vendor-company-combobox'} 
          key={'select-vendor-company-combobox'} 
          width={370} 
          height={24}
          hasBorder={false}
          noBackground={false} 
          initialValue="Select a Company"
          handleSelection={this.handleCompanySelection} 
          currentSelectedCompany={this.state.selectedCompany} 
          adjustHeight={false} 
          companies={this.state.company ? this.state.company.vendor_companies : []} />
      </div>;

    let marketMatrix = null;
    let marketMatrixTitle = null;
    if (this.state.selectedCompany && this.state.vendorMarketUsers) {

      const filteredVendorUsers = this.state.vendorMarketUsers
        .sort((user1, user2) => {
          if (user1.last_name < user2.last_name) return -1;
          else if (user1.last_name > user2.last_name) return 1;
          else return 0;
        });
      let usersList = [], marketSelections = [];
      
      let marketTitles = this.state.markets.map(market => {
        return <div key={`market-code-${market.code}`} className='market-title'>{market.code}</div>;
      });

      let marketHeight = 4;
      filteredVendorUsers.forEach(user =>{
        usersList.push(<div key={`user-row-${user.id}`} className='vendor-user-row'>
          {user.last_name + ', ' + user.first_name}
        </div>
        );

        let marketSelectors = this.state.markets.map(market => {
          let found = false;
          if(user.vendor_markets){
            user.vendor_markets.forEach(userMarket => {
              if(userMarket.id == market.id){
                found = true;
              }
            });
          }
          if(found){
            return <div key={'market-selector-' + user.id + '-' + market.id} className='market-selector'>
          <img id={user.id + '-' + market.id}
            data-market-id={market.id} 
            data-user-id={user.id} 
            src={fillCheckmark} 
            alt='' 
            onClick={this.handleCheckmarkUnClick}/>
          </div>;
          }
          else{
            return <div key={'market-selector-' + user.id + '-' + market.id} className='market-selector'>
            <img id={user.id + '-' + market.id}
              data-market-id={market.id} 
              data-user-id={user.id} 
              src={emptyCheckmark} 
              alt='' 
              onClick={this.handleCheckmarkClick}/>
          </div>;
          }
        });
        marketHeight += 24;
        marketSelections.push(<div key={`market-row-${user.id}`}className='market-row'>
          {marketSelectors}
        </div>);
      });
      marketMatrixTitle = <div className='label'>SELECT {this.textMap.users.toUpperCase()}/{this.textMap.markets.toUpperCase()}</div>;
      marketMatrix = <div className='market-matrix'>
        <div className='label-container'>
          <div className='user-label'>{this.textMap.users.toUpperCase()}</div>
          <div className='divider'/>
          <div className='market-label-container'>
            <div className='market-label'>{this.textMap.markets.toUpperCase()}</div>
            <div id='market-titles' onScroll={this.handleScrollTitles} className='market-title-row'>{marketTitles}</div>
          </div>
        </div>
        <div className='scroll-container'>
          <div className='users-container'>
            {usersList}
          </div>
          <div onScroll={this.handleScrollCheckBoxes} id='market-checkboxes' className='markets-container' style={{ height: marketHeight }}>
            {marketSelections}
          </div>
        </div>
      </div>;
    }
    return (
      <div id={this.props.id} className="vendor-user-selection" >
        <div>
          <div className='vendor-user-selection-body'>
            <div className='label'>SELECT COMPANY</div>
            {companySelector}
            {marketMatrixTitle}
            {marketMatrix}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps)(VendorUserSelection);



// WEBPACK FOOTER //
// ./src/containers/Directory/VendorUserSelection/index.js